
import React from 'react';

const CSR: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 md:py-16 space-y-32">
      {/* Header Section */}
      <section className="flex flex-col items-center text-center space-y-12">
        <div className="animate-in fade-in slide-in-from-top-4 duration-700">
          <h1 className="text-6xl md:text-[9rem] font-black leading-[0.85] tracking-tighter serif-heading !text-grow-green max-w-5xl mx-auto">
            Corporate <span className="italic">Social</span> <br className="hidden md:block" /> Responsibility
          </h1>
        </div>

        {/* Hero Image */}
        <div className="w-full animate-in fade-in zoom-in duration-700 delay-150">
          <div className="relative group">
            <div className="absolute -inset-4 bg-emerald-200/20 blur-3xl rounded-[64px] transition-all group-hover:bg-emerald-200/40"></div>
            <img 
              src="https://i.imgur.com/rDjyk9d.png" 
              alt="Community volunteering and food distribution" 
              className="relative z-10 w-full rounded-[48px] shadow-2xl object-cover h-[400px] md:h-[600px] transition-transform duration-700 group-hover:scale-[1.01]"
            />
          </div>
        </div>

        {/* CSR Core Text */}
        <div className="max-w-4xl mx-auto space-y-12 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300">
          <div className="modern-card p-12 md:p-16 text-left border-l-8 border-grow-green">
            <p className="text-xl md:text-2xl text-emerald-900/70 leading-relaxed font-medium">
              GrowLocal’s Corporate Social Responsibility (CSR) acknowledges the complex and persistent issue of food insecurity within our local communities. We are committed to addressing this challenge through meaningful company initiatives that extend support to families in need, going well beyond simply providing our product.
            </p>
          </div>
        </div>
      </section>

      {/* GoFundMe Fundraiser Section */}
      <section className="space-y-12">
        <div className="text-center animate-in fade-in slide-in-from-top-4 duration-700">
          <h2 className="text-6xl md:text-7xl font-black serif-heading !text-grow-green leading-tight">
            GoFundMe <span className="italic">Fundraiser</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="order-2 lg:order-1 animate-in fade-in slide-in-from-left-8 duration-700">
            <div className="relative group max-w-[420px] mx-auto">
              <div className="absolute -inset-6 bg-grow-green/5 blur-3xl rounded-full"></div>
              <a 
                href="https://gofund.me/bbb5db69d" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="modern-card p-12 bg-white flex items-center justify-center relative z-10 aspect-square shadow-xl"
              >
                <img 
                  src="https://logos-world.net/wp-content/uploads/2021/02/GoFundMe-Logo.png" 
                  alt="GoFundMe Logo" 
                  className="w-full max-w-[320px] object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 space-y-8 animate-in fade-in slide-in-from-right-8 duration-700">
            <div className="space-y-6 text-lg text-emerald-900/70 font-medium leading-relaxed">
              <p>
                At GrowLocal, our mission is to combat food insecurity through accessible and sustainable food solutions. While our gardening kits empower families to grow their own nutritious produce, we also recognize the need to address urgent and immediate food needs. 
              </p>
              <p>
                Baby formula is consistently one of the most in-demand items at food banks, yet rising costs have made it increasingly difficult for families to afford. While an adult may be able to skip a meal, a baby cannot and missing essential nutrition at such a critical stage can have serious consequences. 
              </p>
              <p>
                Through our GoFundMe fundraiser, we are raising funds to purchase and donate baby formula, ensuring vulnerable families have access to the nourishment they need. Your support can make a meaningful difference in our community!
              </p>
            </div>

            <div className="pt-4">
              <a 
                href="https://gofund.me/bbb5db69d" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary inline-flex items-center gap-3 !bg-grow-green shadow-emerald-900/20"
              >
                Support our Fundraiser
                <span className="text-xl">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Feed Scarborough Section */}
      <section className="grid lg:grid-cols-2 gap-16 items-center">
        <div className="space-y-8 animate-in fade-in slide-in-from-left-8 duration-700">
          <div className="space-y-4">
            <h2 className="text-6xl md:text-7xl font-black serif-heading !text-grow-green">Our Initiative</h2>
          </div>
          
          <div className="space-y-6 text-lg text-emerald-900/70 font-medium leading-relaxed">
            <p>
              We donated to the Scarborough Food Security Initiative, which is a community-driven initiative that began distributing holiday hampers in 2018, as we believe that real change starts locally. The contribution supports more than a meal. We are proud to stand with the Scarborough Food Security Initiative as they grow from holiday hampers into a force for long-term empowerment.
            </p>
          </div>
        </div>

        <div className="animate-in fade-in slide-in-from-right-8 duration-700">
          <div className="relative group">
            <img 
              src="https://i.imgur.com/J2BcFHt.png" 
              alt="Grow Local team supporting Feed Scarborough" 
              className="rounded-[40px] shadow-2xl object-cover h-[500px] w-full"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default CSR;
